import { render, staticRenderFns } from "./cwvDomainsFilterCard.vue?vue&type=template&id=bcc9ed98"
import script from "./cwvDomainsFilterCard.vue?vue&type=script&lang=ts"
export * from "./cwvDomainsFilterCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports